// eslint-disable-next-line import/prefer-default-export
export const ISSUE_STATUSES = {
  FOUND: 'found',
  FIXED: 'fixed',
  OPEN: 'open',
};
